import { render, staticRenderFns } from "./UblSendModal.vue?vue&type=template&id=7893c9f1&scoped=true"
import script from "./UblSendModal.vue?vue&type=script&lang=ts"
export * from "./UblSendModal.vue?vue&type=script&lang=ts"
import style0 from "./UblSendModal.vue?vue&type=style&index=0&id=7893c9f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7893c9f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7893c9f1')) {
      api.createRecord('7893c9f1', component.options)
    } else {
      api.reload('7893c9f1', component.options)
    }
    module.hot.accept("./UblSendModal.vue?vue&type=template&id=7893c9f1&scoped=true", function () {
      api.rerender('7893c9f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/UblSendModal.vue"
export default component.exports